// src/PrivateRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function AdminRoute({children}) {
  const { currentUser } = useAuth();

  // Liste des emails autorisés
  const authorizedEmails = [
    "dg@conseiletfina.com",
    "sekre.yao@conseiletfina.com",
    "akafy3a@yahoo.fr"
  ];

  // Si l'email n'est pas dans la liste des autorisés
  if (!authorizedEmails.includes(currentUser?.email)) {
    return <Navigate to="/" replace />;
  }

  // Si l'email est autorisé
  return children;
}
